import { render, staticRenderFns, recyclableRender, components } from "./table-view.vue?vue&type=template&id=00f820e0&"
var renderjs
import script from "./table-view.vue?vue&type=script&lang=js&"
export * from "./table-view.vue?vue&type=script&lang=js&"
import style0 from "./table-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/table/table-view.vue"
export default component.exports